// Esta funcion se invoca desde kyop-pub login_es\bbvaoneview_login.html

/* eslint-disable */
function openwebInitialization (config) {
  //Set base html5 support
  var base = document.createElement('base');
  var baseHref = config.openwebPath.split('/').slice(0, 3).join('/') + '/';
  base.href = baseHref;
  document.head.appendChild(base);


  // Redirect to https
  var loc = window.location.href + '';
  if (loc.indexOf('http://') === 0) {
    window.location.href = loc.replace('http://', 'https://');
  }

  var basePath, adobePath1, adobePath2;
  // var opinatorPath = '//www.opinator.com/api/file-inline/embed.boss.min.js/';
  switch (config.origen) {
    case '': // local
      basePath = '//localhost:3000';
      adobePath1 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/dev/utag.sync.js';
      adobePath2 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/dev/utag.js';
      break;

    case 'ad.bbva.com:3000': // local red interna
      basePath = '//d1z5tqtqqbiamk.cloudfront.net';
      adobePath1 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/dev/utag.sync.js';
      adobePath2 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/dev/utag.js';
      break;

    case 'igrupobbva': // pre-produccion
      basePath = '//d1z5tqtqqbiamk.cloudfront.net';
      adobePath1 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/dev/utag.sync.js';
      adobePath2 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/dev/utag.js';
      break;

    case 'bbvaoneview.com': // produccion
      basePath = '//jiofwv2h.openweb.bbva';
      adobePath1 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/prod/utag.sync.js';
      adobePath2 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/prod/utag.js';
      break;

    default:
      basePath = '//jiofwv2h.openweb.bbva';
      adobePath1 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/prod/utag.sync.js';
      adobePath2 = '//tags.tiqcdn.com/utag/bbva/es-oneview-web/prod/utag.js';
  }

  // remote scripts loader
  [
    {file: adobePath1, onload: angularInit}
  ].forEach(function (src) {
    var script = document.createElement('script');
    // si la ruta es absoluta no concatenes
    script.src = (src.file[0] !== '/') ? [config.openwebPath, src.file].join('/') : src.file;
    script.type = 'text/javascript';
    if (src.onload) {script.onload = src.onload, script.onerror = src.onload;}
    if (src.defer) {script.defer = src.defer;}
    document.head.appendChild(script);
  });
  angularInit();
  
  function angularInit () {
    (function (a, b, c, d) {
      a = adobePath2;
      b = document;
      c = 'script';
      d = b.createElement(c);
      d.src = a;
      d.type = 'text/java' + c;
      d.async = true;
      a = b.getElementsByTagName(c)[0];
      a.parentNode.insertBefore(d, a);
    })();
    angular.module('bossApp')
      .constant('openwebPath', config.openwebPath)
      .constant('originPath', config.origen);
    angular.bootstrap(document, ['bossApp']);
  }
}

/* eslint-enable */
